import React, { useCallback } from 'react';
/**
 * ConfirmEmailField
 * -----------------
 * What:
 *   Email confirmation input that blocks paste and validates “same as email”.
 *
 * Why:
 *   - Prevent accidental copy/paste errors and encourage deliberate re‑entry.
 *   - Provide gentle client‑side feedback; server still enforces sameAs.
 *
 * UX:
 *   - Disabled until the primary email has a value (and format is OK upstream).
 *   - Smoothly shows/hides validation messages; no placeholder for clarity.
 */

export default function ConfirmEmailField({ id = 'ref_email_confirm', label = 'Confirm email address', value, onChange, originalValue, required, disabled = false, validOverride }) {
  const handlePasteBlock = useCallback((e) => { e.preventDefault(); }, []);
  const fallbackEmailPattern = /^\S+@\S+\.\S+$/;
  const computedValid = !value || (fallbackEmailPattern.test(value) && value === originalValue);
  const valid = validOverride !== undefined ? !!validOverride : computedValid;
  const showError = !disabled && !!value && !valid;

  return (
    <div className="m-1 mb-4">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}{required ? <span className="text-red-600"> *</span> : null}
      </label>
      <input
        id={id}
        type="email"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        onPaste={handlePasteBlock}
        required={required}
        disabled={disabled}
        className={`w-full p-3 border-2 rounded-lg ${disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : 'bg-white'} text-base focus:outline-none focus:ring-2 focus:ring-primary ${valid ? 'border-gray-200' : 'border-red-300'}`}
        placeholder=""
      />
      <div className={`transition-all duration-300 overflow-hidden ${showError ? 'max-h-6 mt-1' : 'max-h-0 mt-0'}`}>
        <div className={`text-xs text-red-600 ${showError ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>
          Emails must match and be valid.
        </div>
      </div>
    </div>
  );
}


